import { SelectFields } from '@repo/toolkit/types'

import { AffectedStaff } from '../../lib/types/models/affectedStaff/affected-staff'
import { FieldsSelector } from '../../lib/types/utils'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getCenterManager<T extends FieldsSelector<AffectedStaff>>(id: number, fields: T) {
  return restApiClient
    .url(encodeNestedObject(constructApiUrl(API.centers.getManager.url, { id }), { fields }))
    .get<SelectFields<AffectedStaff, T>>()
}
